import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';

const CartItem = ({ item, itemType }) => {
  const { updateQuantity, removeItem } = useCart();
  const [isUpdating, setIsUpdating] = useState(false);

  // Extract item details based on type
  const getItemDetails = () => {
    switch (itemType) {
      case 'medicine':
        return {
          name: item.medicine?.name || 'Unknown Medicine',
          price: item.medicine?.offer_price || 0,
          image: item.medicine?.image,
          quantity: item.quantity,
        };
      case 'test':
        return {
          name: item.test?.title || item.package?.name || 'Unknown Test',
          price: item.test?.offer_price || item.package?.offer_price || 0,
          image: item.test?.image || item.package?.image,
          quantity: item.quantity,
        };
      case 'service':
        return {
          name: item.service?.title || 'Unknown Service',
          price: item.service?.offer_price || 0,
          image: item.service?.image,
          quantity: item.quantity,
        };
      default:
        return { name: '', price: 0, image: '', quantity: 0 };
    }
  };

  const details = getItemDetails();

  const handleQuantityChange = async (newQuantity) => {
    // If quantity reaches 0, remove the item without confirmation
    if (newQuantity < 1) {
      setIsUpdating(true);
      try {
        await removeItem(itemType, item.id);
      } catch (error) {
        console.error('Error removing item:', error);
        alert(error.message);
      } finally {
        setIsUpdating(false);
      }
      return;
    }

    setIsUpdating(true);
    try {
      await updateQuantity(itemType, item.id, newQuantity);
    } catch (error) {
      console.error('Error updating quantity:', error);
      alert(error.message);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleRemove = async () => {
    if (!window.confirm('Remove this item from cart?')) return;

    setIsUpdating(true);
    try {
      await removeItem(itemType, item.id);
    } catch (error) {
      console.error('Error removing item:', error);
      alert(error.message);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      gap: '1rem',
      padding: '1rem',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      marginBottom: '1rem',
      opacity: isUpdating ? 0.6 : 1,
      pointerEvents: isUpdating ? 'none' : 'auto',
    }}>
      {/* Item Image */}
      {details.image && (
        <img
          src={details.image}
          alt={details.name}
          style={{
            width: '80px',
            height: '80px',
            objectFit: 'cover',
            borderRadius: '8px',
          }}
        />
      )}

      {/* Item Details */}
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>
          {details.name}
        </h3>
        <p style={{ margin: '0 0 0.5rem 0', color: '#28a745', fontWeight: 'bold' }}>
          ₹{details.price}
        </p>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          Subtotal: ₹{item.subtotal}
        </p>
      </div>

      {/* Quantity Controls */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <button
            onClick={() => handleQuantityChange(details.quantity - 1)}
            disabled={isUpdating}
            style={{
              width: '30px',
              height: '30px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              background: 'white',
              cursor: isUpdating ? 'not-allowed' : 'pointer',
              fontSize: '18px',
            }}
          >
            -
          </button>
          <span style={{ minWidth: '30px', textAlign: 'center', fontWeight: 'bold' }}>
            {details.quantity}
          </span>
          <button
            onClick={() => handleQuantityChange(details.quantity + 1)}
            disabled={isUpdating}
            style={{
              width: '30px',
              height: '30px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              background: 'white',
              cursor: 'pointer',
              fontSize: '18px',
            }}
          >
            +
          </button>
        </div>

        <button
          onClick={handleRemove}
          disabled={isUpdating}
          style={{
            padding: '0.5rem 1rem',
            border: 'none',
            borderRadius: '4px',
            background: '#dc3545',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.9rem',
          }}
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default CartItem;
